module.exports = __webpack_public_path__ + "media/t_noteup.3cc4ffc9.webm";